import { render, staticRenderFns } from "./CanonicalExerciseList.vue?vue&type=template&id=3c21bca8&scoped=true&"
import script from "./CanonicalExerciseList.vue?vue&type=script&lang=js&"
export * from "./CanonicalExerciseList.vue?vue&type=script&lang=js&"
import style0 from "./CanonicalExerciseList.vue?vue&type=style&index=0&id=3c21bca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21bca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
